import React from "react";

type Props = {
  children: any,
  className?: string,
  
}

const WideTextContainer = ({ children, className = '' }: Props) => {
  return (
    <div className={"container px-4 mx-auto " + className} style={{maxWidth: "1100px"}}>
        <div className="mx-auto">
          {children}
        </div>
    </div>
  );
}

export default WideTextContainer;